export default {
  props: {
    number: {
      type: String,
    },

    body: {
      type: String,
    },

    image: {
      type: Object,
    },
  },
}
